import React, { useEffect } from 'react'
import { Modal, Button, Form, Input } from 'antd'

const CertificationModal = () => {
  const [visible, setVisible] = React.useState(false)
  const [loading, setloading] = React.useState(false)
  const [active, setActive] = React.useState(true)

  useEffect(() => {
    async function fetchData() {
      var url = new URL(process.env.REACT_APP_API+'/view/allView'),
        params = { uid: 21313 }
      Object.keys(params).forEach((key) =>
        url.searchParams.append(key, params[key])
      )
      fetch(url)
        .then((res) => res.json())
        .then((res) => {
          let flag = res.videoNum  > res.viewNum  ? true : false
          setActive(flag)
        })
        .catch((error) => console.log)
    }
    fetchData()
  }, [active])
  const showModal = () => {
    setVisible(true)
  }
  const handleCancel = () => {
    console.log('Clicked cancel button')
    setVisible(false)
  }

  const callAPI = (values) => {
    fetch(process.env.REACT_APP_API+'/downloadpdf', {
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
      method: 'POST',
      body: JSON.stringify(values),
    })
      .then((res) => res.blob())
      .then((res) => {
        setVisible(false)
        setloading(false)
        let objectURL = URL.createObjectURL(res)
        window.open(objectURL)
      })
      .catch((err) => {
        console.log(err)
        setloading(false)
      })
  }
  const onFinish = (values) => {
    setloading(true)
    callAPI(values)
  }

  let dom
  if (active) {
    dom = (
      <div className="container right">
        <div>
          <div className="content bg-finish">
            <p>
              恭喜您學完了所有FineReport的基礎教學影片！
              <br />
              點擊下方按鈕立即領取您的「FineReport線上基礎課程結業證書」。
            </p>
          </div>
          <div className="button-finish">
            <Button
              type="primary"
              onClick={showModal}
              block
              size="large"
              disabled={active}
            >
              領取證書
            </Button>
            <Modal visible={visible} onCancel={handleCancel} footer={false}>
              <h1 className="text-center">領取證書</h1>
              <p>
                為了給您製作專屬的電子證書，我們需要您提供真實的姓名，填寫完成後點確定，頁面會自動下載證書，請注意查收！
              </p>
              <Form
                name="normal_login"
                className="login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
              >
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: '請輸入你的姓名!' }]}
                >
                  <Input placeholder="姓名" />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                    loading={loading}
                    block
                  >
                    確定
                  </Button>
                </Form.Item>
              </Form>
              <p className="modalAlert">
                如有疑問，請隨時聯繫我們 taiwan@fanruan.com
              </p>
            </Modal>
          </div>
        </div>
      </div>
    )
  } else {
    dom = (
      <div className="container right">
        <div>
          <div className="content bg-finish active">
            <p>
              恭喜您學完了所有FineReport的基礎教學影片！
              <br />
              點擊下方按鈕立即領取您的「FineReport線上基礎課程結業證書」。
            </p>
          </div>
          <div className="button-finish">
            <Button
              type="primary"
              onClick={showModal}
              block
              size="large"
              disabled={active}
            >
              領取證書
            </Button>
            <Modal visible={visible} onCancel={handleCancel} footer={false}>
              <h1 className="text-center">領取證書</h1>
              <p>
                為了給您製作專屬的電子證書，我們需要您提供真實的姓名，填寫完成後點確定，頁面會自動下載證書，請注意查收！
              </p>
              <Form
                name="normal_login"
                className="login-form"
                initialValues={{ remember: true }}
                onFinish={onFinish}
              >
                <Form.Item
                  name="username"
                  rules={[{ required: true, message: '請輸入你的姓名!' }]}
                >
                  <Input placeholder="姓名" />
                </Form.Item>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="login-form-button"
                    loading={loading}
                    block
                  >
                    確定
                  </Button>
                </Form.Item>
              </Form>
              <p className="modalAlert">
                如有疑問，請隨時聯繫我們 taiwan@fanruan.com
              </p>
            </Modal>
          </div>
        </div>
      </div>
    )
  }
  return dom
}

export default CertificationModal
